import { onMounted, onUpdated } from 'vue'
import { notifyUpdate, notifyMount } from '@/user/homepage-integration'

export default function() {

  onUpdated(() => {
    notifyUpdate()
  })

  onMounted(() => {
    notifyMount()
  })
}
